/**
 * Gets the CSRF token that Rails supplies via a meta tag
 * If the meta tag is not present, returns null
 */
export function getCsrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
}
